var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mb-5 pt-2"},[_c('div',{staticClass:"ml-khong-ton-tai text-center"},[_c('img',{staticClass:"not-found",attrs:{"src":require("mlearn/icons/not-found.svg"),"alt":"Not found"}}),_vm._v(" "),_c('div',{staticClass:"text pt-3"},[_vm._v("Không tìm thấy trang này")])])])
}]

export { render, staticRenderFns }